module.exports = __webpack_public_path__ + "static/media/head-social.55eb6349.svg";